import { Flex } from "@chakra-ui/react";
import About from "./About";
import Contact from "./Contact";
import Home from "./Home";
import Work from "./WorkPages/Work";
import Resume from "./Resume";
import { Parallax } from "react-scroll-parallax";
import ArtGallery from "./WorkPages/ArtGallery";

export default function Main() {
  return (
    <div role="main" style={{ scrollSnapType: "y mandatory" }}>
      <Flex
        scrollSnapType={"y"}
        flexDir={"column"}
        bgAttachment="fixed"
        bgSize="cover"
        // backgroundImage={"/images/background1.jpg"}
        backgroundColor="rgba(245, 243, 239, 1)"
        //backgroundBlendMode={{ lg: "none", base: "lighten" }}
      >
        <Home />
        <Work />
        <ArtGallery/>
        <Resume />
        <About />
        <Contact />
      </Flex>
    </div>
  );
}
